import React from 'react'
import Carousel from './Carousel1'

const Banner = () => {
  return (
    
    <Carousel/>
  )
}

export default Banner